import { createSlice } from '@reduxjs/toolkit';

const priceStrategySlice = createSlice({
  name: 'priceStrategySlice',
  initialState: {
    isLoading: false,
    isViewLoading: false,
    isSyncLoading: false,
    isAssignLoading: false,
    priceStrategyListData: [],
    isError: null,
    viewError: null,
    viewPriceStrategyDetails: null,
    filters: {
      search: '',
      status: '',
    },
  },
  reducers: {
    /////// Price Strategy list start //////
    requestPriceStrategyList: (state) => {
      return { ...state, isLoading: true };
    },
    responsePriceStrategyList: (state, action) => {
      // Handle different response structures:
      // { data: { list: [], total: 0, ... } } or { data: [], total: 0 } or direct array
      const responseData = action?.payload?.data || action?.payload;
      return {
        ...state,
        isLoading: false,
        priceStrategyListData: {
          data: responseData?.list || responseData?.data || responseData || [],
          total: responseData?.total || responseData?.count || 0,
          page: responseData?.page || 1,
          limit: responseData?.limit || 10,
        },
      };
    },
    failurePriceStrategyList: (state, action) => {
      return {
        ...state,
        isLoading: false,
        isError: action?.payload,
      };
    },

    /////// Price Strategy Add-Edit //////
    requestPriceStrategyAdd: (state) => {
      return { ...state, isLoading: true };
    },
    responsePriceStrategyAdd: (state) => {
      return { ...state, isLoading: false };
    },
    failurePriceStrategyAdd: (state, action) => {
      return { ...state, isLoading: false, isError: action?.payload };
    },

    ////////// Price Strategy View /////////
    requestPriceStrategyView: (state) => {
      return { ...state, isViewLoading: true, viewError: null };
    },
    responsePriceStrategyView: (state, action) => {
      return {
        ...state,
        isViewLoading: false,
        viewError: null,
        viewPriceStrategyDetails: action.payload,
      };
    },
    failurePriceStrategyView: (state, action) => {
      // RAT-1928: kept separate from isError so the detail/edit screens can render
      // a denied state instead of spinning forever on a cross-region record.
      return {
        ...state,
        isViewLoading: false,
        isError: action?.payload,
        viewError: action?.payload,
        viewPriceStrategyDetails: null,
      };
    },

    ////// Price Strategy Delete ////
    requestPriceStrategyDelete: (state) => {
      return { ...state, isLoading: true };
    },
    responsePriceStrategyDelete: (state) => {
      return { ...state, isLoading: false };
    },
    failurePriceStrategyDelete: (state, action) => {
      return { ...state, isLoading: false, isError: action?.payload };
    },

    ////// Price Strategy Sync ////
    requestPriceStrategySync: (state) => {
      return { ...state, isSyncLoading: true };
    },
    responsePriceStrategySync: (state) => {
      return { ...state, isSyncLoading: false };
    },
    failurePriceStrategySync: (state, action) => {
      return { ...state, isSyncLoading: false, isError: action?.payload };
    },

    ////// Price Strategy Assign Merchants ////
    requestAssignMerchants: (state) => {
      return { ...state, isAssignLoading: true };
    },
    responseAssignMerchants: (state) => {
      return { ...state, isAssignLoading: false };
    },
    failureAssignMerchants: (state, action) => {
      return { ...state, isAssignLoading: false, isError: action?.payload };
    },

    ////// Price Strategy Filters ////
    setPriceStrategyFilters: (state, action) => {
      return { ...state, filters: { ...state.filters, ...action.payload } };
    },
    clearPriceStrategyFilters: (state) => {
      return {
        ...state,
        filters: {
          search: '',
          status: '',
        },
      };
    },
  },
});

export const {
  failurePriceStrategyList,
  requestPriceStrategyList,
  responsePriceStrategyList,
  failurePriceStrategyAdd,
  requestPriceStrategyAdd,
  responsePriceStrategyAdd,
  failurePriceStrategyView,
  requestPriceStrategyView,
  responsePriceStrategyView,
  failurePriceStrategyDelete,
  requestPriceStrategyDelete,
  responsePriceStrategyDelete,
  requestPriceStrategySync,
  responsePriceStrategySync,
  failurePriceStrategySync,
  setPriceStrategyFilters,
  clearPriceStrategyFilters,
  requestAssignMerchants,
  responseAssignMerchants,
  failureAssignMerchants,
} = priceStrategySlice.actions;

export default priceStrategySlice.reducer;
